import { useEffect, type ReactElement, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { SEARCH_TABS_PARAM } from '@citibox-panel/lockers-care';
import { completeTabHandoff, isTabHandoffPending, withoutParam } from '@/lib/tabHandoff';

// Open search tabs name «Usuarios» by phone, so they never pass from one person to the next. The
// strip happens here, where the next person lands, because the login redirect cannot know who that is.
export function ForeignTabsGuard({ uid, children }: { uid: string; children: ReactNode }): ReactElement {
  const location = useLocation();
  const pending = isTabHandoffPending(uid);
  const carriesTabs = new URLSearchParams(location.search).has(SEARCH_TABS_PARAM);

  useEffect(() => {
    if (pending && !carriesTabs) completeTabHandoff(uid);
  }, [pending, carriesTabs, uid]);

  if (pending && carriesTabs) {
    return (
      <Navigate
        to={{ pathname: location.pathname, search: withoutParam(location.search, SEARCH_TABS_PARAM) }}
        replace
      />
    );
  }
  return <>{children}</>;
}
